import { goFish } from '../api';
import autoComplete from '@tarekraafat/autocomplete.js'; // Defs not available :(

const HIGHLIGHT_CLASS = 'Input__reshighl';
const RESULT_CLASS = 'Input__result';
const LIST_CLASS = 'Input__list';
const CLEAR_CLASS = 'Input__element--clear';

export const setupAutocomplete = (
    field: HTMLInputElement,
    fishingParams: (prefixValue: string) => APICall,
    validateValue: (value: string) => boolean,
    nextField?: HTMLInputElement
) => {
    // Get delay value from input attribute
    const autoData = {
        results: [] as string[],
        possibleResults: [] as string[],
        checkPossibleResults: false,
        debounce: field.getAttribute('data-delayms'),
        maxResults: field.getAttribute('data-maxres'),
        pending: false
    };
    // Get possible results
    if (fishingParams('').api === 'citysearch') {
        goFish({ api: 'list' }).then((res: LocalsList) => {
            if (res && res.Data) {
                res.Data.map(local => {
                    if (autoData.possibleResults.indexOf(local.City) == -1) {
                        autoData.possibleResults.push(local.City.toLowerCase());
                    }
                });
                if (autoData.possibleResults.length) {
                    autoData.checkPossibleResults = true;
                }
            }
        }).catch(e => {});
    }
    //
    new autoComplete({
        data: {
            src: async () => {
                autoData.pending = true;
                const _value = field.value && field.value.trim();
                // Trigger condition is not workin as expected so here prevent unnecesary calls
                if (!validateValue(_value)) {
                    autoData.pending = false;
                    return [];
                }
                try {
                    const source: SearchList = await goFish(fishingParams(_value));
                    // Save results
                    autoData.results = (source.Status && source.Data) || [];
                    autoData.pending = false;
                    // Handle Status and return list if it's fine
                    if (source.Status) {
                        field.classList.remove(CLEAR_CLASS);
                        // If found value is the same as typed
                        // do not show autocomplete
                        if (source.Data &&
                            source.Data.length === 1 &&
                            field.value === source.Data[0]
                        ) {
                            return [];
                        }
                        return source.Data || [];
                    } else {
                        return [];
                    }
                } catch (e) {
                    autoData.pending = false;
                    return [];
                }
            },
            cache: false
        },
        trigger: {
            event: ['input', 'focusin']
        },
        selector: () => field,
        debounce: autoData.debounce ? parseInt(autoData.debounce) : 300,
        searchEngine: 'strict',
        resultsList: {
            render: true,
            container: (source: any) => {
                source.setAttribute('class', LIST_CLASS);
                source.removeAttribute('id');
                source.setAttribute(`data-${field.name.toLowerCase()}-results`, '');
            }
        },
        maxResults: autoData.maxResults ? parseInt(autoData.maxResults) : 10,
        highlight: true,
        resultItem: {
            content: (data: any, source: any) => {
                source.setAttribute('class', RESULT_CLASS);
                source.innerHTML = data.match.replace('autoComplete_highlighted', HIGHLIGHT_CLASS);
            }
        },
        onSelection: (feedback: any) => {
            field.value = feedback.selection.value;
            if (nextField && !nextField.value) {
                setTimeout(() => nextField.focus(), 0);
            }
        }
    });

    // Prevents sending form on list item selection
    field.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    });
    // Hide results list if still open on blur
    field.addEventListener('blur', (e: FocusEvent) => {
        if (!autoData.pending) {
            field.classList.add(CLEAR_CLASS);

            // Fill in field (this is case when there might be typo or some trash)
            if (
                field.value &&
                autoData.results.length &&
                autoData.results.indexOf(field.value) == -1 &&
                (
                    !autoData.checkPossibleResults ||
                    (// Small letter fix
                        autoData.results[0].toLowerCase() === field.value.toLowerCase() ||
                        (// When value is not one of possible results
                            autoData.possibleResults.indexOf(field.value.toLowerCase()) == -1 &&
                            // and start is similar to our data
                            autoData.results[0].toLowerCase().slice(0, 3) === field.value.toLowerCase().slice(0, 3)
                        )
                    )
                )
            ) {
                field.value = autoData.results[0];
            }
        }
    });
};
